// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8398fc96","455":"36b208d3","977":"27c8e462"}[chunkId] + ".chunk.js";
};